import axios from "axios";
import { useEffect, useState } from "react";
import styles from "./App.module.scss";
import {useRouteMatch } from "react-router-dom";
import qr from "./images/qr.svg";
import {AddressIcon, ErrorIcon, InstIcon, Logo, SiteIcon, VkIcon} from "./components/icons";

function App() {
  let [cooking, setCooking] = useState([]);
  let [ready, setReady] = useState([]);
  let [errorText, setErrorText] = useState('');
  let [name, setName] = useState("");
  let [sliderImages, setSliderImages] = useState([]); // Состояние для изображений слайдера
  let [currentSlide, setCurrentSlide] = useState(0); // Текущий индекс слайда

  let rest_id = "";
  let match = useRouteMatch('/:rest_id');
  if(match && match.isExact){
    rest_id = match.params.rest_id;
  }

  function getInfo(rest_id) {
    axios.get("https://controlling.sushifuji.ru/client_dashboard/~" + rest_id).then((response) => {
      if (response.data.error === 0) {
        setCooking(response.data.cooking);
        setReady(response.data.ready);
        setName(response.data.name);
        setErrorText('');
        
        // Обновляем изображения слайдера
        if (response.data.actions && response.data.actions.length > 0) {
          setSliderImages(response.data.actions);
        } else {
          setSliderImages([]);
        }
      } else {
        setErrorText(response.data.error_text);
      }
    }).catch(() => {
        setErrorText("Нет соединения с сайтом");
    });
  }

  useEffect(() => {
    getInfo(rest_id);
    let interval = setInterval(() => {
      getInfo(rest_id);
    }, 10000);
    return () => {
      clearInterval(interval);
    };
  }, [rest_id]);

  // Эффект для автоматической смены слайдов
  useEffect(() => {
    if (sliderImages.length > 0) {
      const slideInterval = setInterval(() => {
        setCurrentSlide(prev => (prev + 1) % sliderImages.length);
      }, 9000);
      
      return () => clearInterval(slideInterval);
    }
  }, [sliderImages]);

  return (
    <>
      <div className="container">
        <div className="orders">
        <div className="orders_column">
          <div className="column_name column_name_cooking">
            Готовятся
          </div>
          <div className="orders_cooking">
            <ListOrders orders={cooking} />           
            </div>         
        </div>

        <div className="orders_column">
          <div className="column_name column_name_ready">
            Готовы
          </div>
          <div className="orders_ready">
            <ListOrders orders={ready} />
            </div>
        </div>
          
        </div>
        <div className="info">
            <div className="info_slider">
              {sliderImages.length > 0 && (
                <div className="slide-container">
                  <img 
                    src={'https://sushifuji.ru'+sliderImages[currentSlide]+'_action_coocked_min.jpg'} 
                    alt={`Акция ${currentSlide + 1}`}
                    className="slide-image"
                  />
                </div>
              )}
            </div>
            <div className="info_qr">
              <span>
                Наше приложение<br></br> и соцсети
              </span>

              <div className="info_qr_image">
              <img src={qr} />
              </div>
            </div>
        </div>
      </div>
    </>
  );
};


function ListOrders(props) {

  let order_list_smoll = '';
  if(props.orders.length >= 13) order_list_smoll = 'order_list_smoll';
  return (
    
    <div className={styles.list_orders + ' ' + order_list_smoll}>
      {props.orders.map((el) =>

        el.number.length > 0 &&
        el.name.length > 0 &&
          <div className="order_list" key={el.number}>
            <div className="order_name">
            {el.name.split(" ").length === 1 ? el.name : el.name.split(" ")[0] + " " + el.name.split(" ")[1][0] + "."}{" "}
            </div>
            <div className="order_number">
            { el.number.substring(0,3) + '-' + el.number.substring(3)}
            </div>
          </div>
          
          
          

          
      )}
    </div>
  );
}

export default App;
